export const USER_INFO_ROUTING = {
  PARENT_ROUTE: '/ca-nhan/tai-khoan/',
  ACTIVE_TABS: {
    DISPLAY_TAB_ACCOUNT: 'thong-tin',
    DISPLAY_TAB_RESET_PWD: 'doi-mat-khau',
    DISPLAY_TAB_CHANGE_PHONE_NUMBER: 'doi-so-dien-thoai',
    DISPLAY_TAB_ALERTS: 'thong-bao',
    LINK_THIRT_PARTY_ACCOUNT: 'lien-ket-tai-khoan',
    CHANGE_PASSWORD_EMAIL_HUTECH: 'reset-password-email',
  },
};

/**
 * Link account information use to navigate
 */
export const ACCOUNT_ROUTE_LINK =
  USER_INFO_ROUTING.PARENT_ROUTE +
  USER_INFO_ROUTING.ACTIVE_TABS.DISPLAY_TAB_ACCOUNT;
